require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-hormones-and-the-gut.json") })
        }
      }, "path---blog-hormones-and-the-gut");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-hormones-and-the-gut!./.cache/json/blog-hormones-and-the-gut.json
// module id = 291
// module chunks = 231608221292675